module.exports = __webpack_public_path__ + "media/images/robot_falha_mail-00ba98bbedad22a89da092dd8ea391b2.svg";